module.exports = __webpack_public_path__ + "static/media/email-contact.bba9f425.jpg";